export default {
  faqs: []
}
